<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Aboutus page
@Last modified by:   tom
@Last modified time: 2018-02-06T10:17:25+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page
    id="upgrade"
    :title="$t('upgrade.title')"
    sideimage="@/assets/img/upgrade/upgrade-site.jpg">

    <h2 class="text-secondary">{{ $t('upgrade.header') }}</h2>
    <p v-html="$t('upgrade.intro') + version"/>

    <b-button variant="warning" @click="refreshApp()">
      {{ $t('upgrade.click') }}
    </b-button>

  </c-page>
</template>

<script>

export default {
  name: 'Upgrade',
  // To use the version number from package.json all over your code, please add to webpack.config.js
  //   plugins: [
  //     new webpack.DefinePlugin({
  //       VERSION: JSON.stringify(require("../package.json").version)
  //     })
  //   ]

  /* global VERSION */
  computed: {
    version: function () {
      return VERSION
    }
  },
  methods: {
    refreshApp: function () {
      // Refresh app, will hopefully load not from PWA cache...
      // ServiceWorkerRegistration.update();
      console.log('Finding Service Worker...')
      navigator.serviceWorker.getRegistrations().then(registrations => {
        if (typeof registrations !== 'undefined' && registrations.length > 0) {
          console.log('  Service workers found:' + registrations + ' so update now...')
          registrations[0].update()
        } else {
          console.log('  No service workers found.')
        }
        console.log('  Reloading app...')
        window.location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  // @import "../assets/style/theme.scss";

</style>
